import { QueryClientProvider } from "@tanstack/react-query";
import type { ReactNode } from "react";
import { I18nextProvider } from "react-i18next";
import { Toaster } from "sonner";

import i18n from "@/i18n";
import { queryClient } from "@pulse/queryClient";

export default function PulseAppProviders({ children }: { children: ReactNode }) {
    return (
        <I18nextProvider i18n={i18n} defaultNS="pulse">
            <Toaster position="top-right" />
            <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
        </I18nextProvider>
    );
}
